<template>
    <div>
        <el-input
            :placeholder="placeholder"
            :disabled="disabled"
            :size="size"
            :readonly="isReadonly"
            @blur="changeVal"
            v-model="value"
            class="input-with-select"
            width="60%"
        >
            <el-button slot="append" :disabled="disabled" @click="showSelectDialog" icon="el-icon-price-tag"></el-button>
        </el-input>
        <el-dialog title="管理标签" :close-on-click-modal="false" :append-to-body="true" :visible.sync="visible" width="850px">
            <div>
                <el-tag
                    :key="tag"
                    v-for="tag in dynamicTags"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)">
                    {{tag}}
                </el-tag>
                <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                >
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加</el-button>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose()">关闭</el-button>
                <el-button type="primary" @click="doSubmit()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components:{
    },
    data() {
        return {
            visible: false,
            dynamicTags: [],
            inputVisible: false,
            inputValue: '',
        };
    },
    props: {
        size: {
            type: String,
            default: () => {
                return 'small';
            }
        },
        value:{
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isReadonly: {
            type: Boolean,
            default: true
        },
    },
    methods:{
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },
        showSelectDialog(){
            if(this.value){
                this.dynamicTags = this.value.split(",")
            }
            this.visible = true
        },
        dialogClose(){
            this.visible = false
        },
        doSubmit(){
            // this.value = this.dynamicTags.join(",")
            this.$emit('getTagValue',this.dynamicTags.join(","))
            this.visible = false
        },
        changeVal(){

        },
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.i1 {
    width: 50px;
    height: 50px;
    display: block;
    margin-left: 50%;
    transform: translate(-50%, 0);
}

.el-tag + .el-tag {
    margin-left: 10px;
    margin-top: 10px;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
	background-color: #f91e1d;
}
</style>
